import { useContext } from 'react'
import { CookieContext } from 'context/CookieProvider'

export const useSafeCookieContext = () => {
  const context = useContext(CookieContext)

  if (!context) {
    return {
      cookieCountry: null,
      cookieLocale: null,
      consentNecessary: false,
      consentAnalytical: false,
      consentMarketing: false,
      cookies: {},
      setCustomCookie: () => {},
      setCookieLocale: () => {},
      setCookieCountry: () => {},
    }
  }

  return context
}
